import {register} from '@shopify/theme-sections';
import Modal from '../components/modal';
import {setCookie, getCookie} from '../helpers/cookies';

const selectors = {
  target: 'modal--',
};

register('modal', {
  onLoad() {
    const target = `.${selectors.target}${this.id}`;
    const modal = document.querySelector(target);
    this.target = target;
    this.modal = modal;

    if(!this.modal) {return}

    this.init();
  },

  init() {
    this.createModal();
    this.triggerModal();
    this.eventBusListener();
    console.log(`🎥 Modal: Loaded`)
  },

  eventBusListener() {
    Karmoon.EventBus.listen('Modal:Close', (element) => {
      this.modelClosed(element);
    });
  },

  modelClosed(element) {
    if (this.modal == element) {
      setCookie('sign_up', 'closed', 20);
    }
  },

  triggerModal() {
    const hasBeenClosed = getCookie('sign_up');

    if(hasBeenClosed) {return}

    const timer = parseInt(this.modal.dataset.modalDelay);
    const delay = timer * 1000;

    console.log(`⏰ Delay: ${timer} Seconds`)

    window.setTimeout(() => {
      this.openModal()
    }, delay);
  },

  createModal() {
    Modal(this.target,
      {
        showModal: '[js-modal="sign-up"]',
        bodyLock: false,
      }
    ).init();
  },

  openModal() {
    Modal(this.target, {bodyLock: false}).modalOpen();
  },

  closeModal() {
    Modal(this.target).closeModal();
  },

  onSelect: (section) => {
    this.openModal()

    console.log(`👨‍🎤 Modal: It's rocking!`);
  },

  onDeselect: (section) => {
    this.closeModal()

    console.log(`👋 Modal: Thanks for everything!`);
  },
});
